
const loadArticle = slug => {
	return new Promise((resolve, reject) => {
		axios('/api/article/' + slug, { headers: { Accept: 'application/json' }}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

const loadArticles = type => {
	return new Promise((resolve, reject) => {
		axios('/api/articles/' + type, { headers: { Accept: 'application/json' }}).then(res => {
			resolve(res.data)
		}, res => {
			reject(res.response)
		})
	})
}

export {
	loadArticle,
	loadArticles
}